import Cookies from "js-cookie";
import { decrypt } from "../../../../Core/utils/others";
import { getRole, decodeToken } from "../../../../Core/utils/auth";

export const navigateToQuiz = (userData) => {
  const role = getRole();
  const sandbox_user_data = decrypt(localStorage.getItem("sandbox_user_data"));
  const accesToken = decrypt(localStorage.getItem("sandbox_user"));
  const userInfo = decodeToken(accesToken.ACCESS_TOKEN);
  const userId = sandbox_user_data?.studentId || userInfo.userId;
  const allowedUsers = process.env?.REACT_APP_ALLOWED_USERS?.split(",") || [];
  const language = userData?.subject?.toLowerCase();

  const userName = sandbox_user_data?.studentName || accesToken.userName;
  Cookies.set("userName", userName, {
    path: "/",
    domain: ".codeyoung.com",
  });
  if (role != "guest") {
    Cookies.set("grade", sandbox_user_data?.grade, {
      path: "/",
      domain: ".codeyoung.com",
    });
  }
  Cookies.set("userId", userId, {
    path: "/",
    domain: ".codeyoung.com",
  });
  Cookies.set("userRole", role, {
    path: "/",
    domain: ".codeyoung.com",
  });

const url = allowedUsers.includes(accesToken.email)
    ? process.env?.REACT_APP_AI_QUIZ_URL_DEV
    : process.env?.REACT_APP_AI_QUIZ_URL;

  if (!url) return;

    const isPlugin = window.__SANDBOX_IS_PLUGIN__;
  if (userData?.type == "language") {
    window.location.href = `${url}languages?lang=${language}&from=${isPlugin ? "studentPortal" : "sandboxLanguage"}`;
  } else if (userData?.type === "trivia") {
    window.open(`${url}?from=${isPlugin ? "studentPortal" : "sandbox"}&trivia=1`);
  } else {
    window.open(`${url}`);
  }
};
